import sx from 'utils/createSx';

export const LIST_TEXT_PRIMARY_NAV = {
  variant: 'body2' as const,
  sx: { fontWeight: 500 },
};

export const LIST_TEXT_PRIMARY_LOGOUT = {
  variant: 'body2' as const,
  sx: { fontWeight: 600 },
};

export default sx({
  navRoot: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  listItem: { mb: 0.5 },
  listItemIcon: { minWidth: 40 },
  divider: { my: 2 },
});
